import { iRequest } from '../../utils/requestutil';

export async function query(payload) {
  return iRequest(
    `/iwms-openapi/api/field?interfaceName=${payload.interfaceName}`,
  );
}
